/**
 * Module: TableColumn
 * Description: UI for viewing and editing reference tables (Categories, Channels, Territories, Gender).
 * - Fetches table schema + rows from API on selection
 * - Renders an interactive DataTable built from dynamic columns
 * - Allows inline editing (text/select) and batches save operations
 * Notes:
 * - Uses jQuery/DataTables for rendering; React is used for the surrounding UI and save flow.
 */
import React, { useState, useEffect, useRef } from 'react';
import Select from "react-select";
import $ from 'jquery';
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.css";
import 'datatables.net';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { apiCall } from "../../utils/server_utils";
import PageLoader from '../common/pageloader';
import CommonIcon from '../common/customicon';
import { getUsername } from "../../utils/common_functions";
import { trackError } from "../../utils/error_tracker";
import { API_SUCCESS_RESPONSE_CODE } from '../../utils/config_mapping';
import {escapeHTML} from '../../utils/common_functions'
import HeaderLogo  from "../structure/headerlogo";

import Message from "../common/message";
import * as ReactDOM from 'react-dom';

let tempArray = []
let tempModifedId = []

/**
 * TableColumn component
 * Renders the reference data editor with table selection, search and save functionality.
 * @component
 */
export const TableColumn = () => {
  const [loading, setLoading] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [tableContent, setTableContent] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [modifiedData, setModifiedData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [editIds, setEditIds] = useState("");
  const [tableselection, settableselection] = useState("");

  const tableOptions = [
    { label: "Categories", value: "Categories" },
    { label: "Channels", value: "Channels" },
    { label: "Territories", value: "Territories" },
    { label: "Gender", value: "Gender" },
  ];

  
  /**
   * Handle table selection & fetch data
   * Fetches metadata and rows for the selected reference table and prepares them
   * for rendering in DataTables.
   * @param {{label:string,value:string}} selectedOption - selected option from react-select
   * @returns {Promise<void>}
   */
  const handleTableChange = async (selectedOption) => {
    setLoading(true);
    setSearchText("")
    $("#searchClausess").val("")
    setModifiedData([]); // Clear modifications
    try {
      let result = await apiCall("GET", `${API_SERVER_URL}reference/data?table=${selectedOption.value}`);
      //let result = await apiCall("GET", `${API_SERVER_URL}contracts/`);
      settableselection(selectedOption)
      if (result.code === 200 && result.data.length > 0) {

        const tempid = (result.data[0].columnsdata || []).map((item, index) => ({
          ID: `${index + 1}`, // Using index to generate a unique ID
          ...item
      }));


      // console.log("&&&&&&&")
      // alert(JSON.stringify(tempid))
      // console.log("&&&&&&&")

      result.data[0].columnsdata = tempid;

      const tableData = result.data[0];
        setTableContent(tableData.columnsdata);
        setOriginalData(tableData.columnsdata);
        tempArray = tableData.columnsdata;
        setSelectedTable({
          tableName: tableData.tableName,
          columnsNameList: tableData.columnsNameList,
          columnsType: tableData.columnsType
        });

      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    /**
     * Effect: initialize DataTable when `tableContent` or `searchText` changes.
     * Builds the DataTable configuration dynamically from `selectedTable` metadata
     * and inserts HTML input/select controls into the table cells.
     */
    if (tableContent.length > 0 ) {
      $("#contract_grid").DataTable({
        destroy: true,
        "dom": '<"top"f>rt<"bottom"ilp><"clear">',
        scrollX: true,
        lengthMenu:"-1", 
        paging: false, // Disables pagination
        "aLengthMenu": [[5,10,50,100,500, -1], [5,10,50,100,500,"All"]],
        "pagingType": "simple_numbers",
        pageLength: 50, // Set default number of records per page
        scrollY: `${window.innerHeight / 2}px`, // Set height to half of window
       // scrollY:$(".navbar-menu").height()-($("#table_height").height()),
        data: tableContent.filter(row =>
          selectedTable.columnsNameList.some(col =>
            row[col]?.toString().toLowerCase().includes(searchText.toLowerCase())
          )
        ).map((row, rowIndex) => {
          return selectedTable.columnsNameList.reduce((acc, columnKey) => {
            const columnType = selectedTable.columnsType[0][columnKey]?.type;
            const defaultValues = selectedTable.columnsType[0][columnKey]?.defaultValues || [];

            let tempmodifiedData = [];
            let configValue = "";
           
            // if(modifiedData.length > 0 ){
            //   tempmodifiedData = modifiedData.filter(item => item.ID === row["ID"]);
            //   if(tempmodifiedData.length > 0){
            //     configValue = tempmodifiedData[0]['modified'][columnKey].toString()
            //   }else {
            //     configValue = row[columnKey].toString()
            //   }
            // }
            if(row[columnKey]!==null){
              configValue = row[columnKey]
            } 

            acc[columnKey] = columnType === "select" ?
              `<select data-keyid="`+row["ID"]+`" class='table-select' data-row='${rowIndex}' data-column='${columnKey}'>${defaultValues.map(value => `<option value='${escapeHTML(value)}' ${escapeHTML(value) === escapeHTML(configValue) ? "selected" : ""}>${escapeHTML(value)}</option>`).join('')}</select>`
              : `<input data-keyid="`+row["ID"]+`" type='text' class='table-input' data-row='${rowIndex}' data-column='${columnKey}' value='${escapeHTML(configValue)}' />`;
            return acc;
          }, {});
        }),
        columns: selectedTable.columnsNameList.map(col => ({ title: col, data: col })),
        order: [],
      });
    }
  }, [tableContent,searchText]);

  useEffect(() => {
    /**
     * Effect: attach delegated event handlers for inline edits.
     * - `.table-select` change -> update tempArray with selected value
     * - `.table-input` input -> update tempArray with typed value
     * - `#searchClausess` keyup -> update tableContent from tempArray
     * These handlers update a module-level tempArray used to track unsaved edits.
     */
    $(document).on("change", ".table-select", function () {
      const keyId = $(this).attr("data-keyid"); // Get row ID
      const columnKey = $(this).data("column"); // Get column key
      const newValue = $(this).val(); // Get new value
    
      // Find index of row in the table
      const indexFound = tableContent.findIndex(item => item.ID === keyId);
    
      if (indexFound !== -1) {
        const updatedTable = [...tempArray];
        updatedTable[indexFound] = { 
          ...updatedTable[indexFound], 
          [columnKey]: newValue 
        };
        tempArray =  updatedTable;
        tempModifedId.push(keyId)
        console.log("Updated Table Content:", updatedTable);
        
      }
    });


    $(document).on("input", ".table-input", function () {
      const keyId = $(this).attr("data-keyid"); // Get row ID
      const columnKey = $(this).data("column"); // Get column key
      const newValue = $(this).val(); // Get new value
    
      // Find index of row in the table
      const indexFound = tableContent.findIndex(item => item.ID === keyId);
    
      if (indexFound !== -1) {
        const updatedTable = [...tempArray];
        updatedTable[indexFound] = { 
          ...updatedTable[indexFound], 
          [columnKey]: newValue 
        };
        //setTableContent(updatedTable); 
        
        tempArray =  updatedTable;
        tempModifedId.push(keyId)
        
      }
    });
    
    
    $("#searchClausess").on("keyup", function () {
      if(tempArray.length > 0){
          setTableContent(tempArray); 
          //tempArray.length = 0;
      }
    });

    
    // $(document).on("input", ".table-input", function () {
    //   const rowIndex = $(this).data("row");
    //   let keyId = $(this).attr('data-keyid'); // Using attr()
    //   const columnKey = $(this).data("column");
    //   const newValue = $(this).val();
    //   const indexFound = tableContent.findIndex(item => item.ID === keyId);

    //   //tableContent[indexFound][columnKey] = newValue
    //   // console.log("*************")
    //   // console.log(columnKey)
    //   // console.log(tableContent[indexFound]?.columnKey)
    //   // console.log("*************")

    //   if(tableContent[indexFound]!==undefined){
    //     tableContent[indexFound][columnKey] = newValue
    //     //alert(tableContent[indexFound][columnKey])
    //     setTableContent(tableContent)
    //     console.log(tableContent)
    //   }

      //updateTableData(keyId, columnKey, newValue,originalData);
      //const [editIds, setEditIds] = useState("");

    //});
  }, [originalData,tableContent]);


  // const updateTableData = (rowIndex, columnKey, newValue) => {
  //   //alert(rowIndex)
  //   const updatedTable = [...tableContent];
  //   updatedTable[rowIndex] = { ...updatedTable[rowIndex], [columnKey]: newValue };
  
  //   alert(JSON.stringify(updatedTable));

  //   //setTableContent(updatedTable);
  //   const originalRow = originalData[rowIndex];
  //   alert(JSON.stringify(originalRow));
  //   if (originalRow[columnKey] !== newValue) {
  //     alert(updatedTable)

  //     setModifiedData(prev => {
  //       const existingChangeIndex = prev.findIndex(change => change.index === rowIndex);
  //       const modifiedRow = { ...originalRow, [columnKey]: newValue };
  //       if (existingChangeIndex !== -1) {
  //         const updatedChanges = [...prev];
  //         updatedChanges[existingChangeIndex].modified = modifiedRow;
  //         return updatedChanges;
  //       } else {
  //         return [...prev, { index: rowIndex, original: originalRow, modified: modifiedRow }];
  //       }
  //     });
  //   }
  // };


  /**
   * updateTableData
   * Update local modifiedData state when a cell value differs from original data.
   * @param {string} rowIndex - ID of the row being edited
   * @param {string} columnKey - Column key being edited
   * @param {string} newValue - New value typed/selected by the user
   * @param {Array} originalData - Original dataset used to compute diffs
   */
  const updateTableData = (rowIndex, columnKey, newValue,originalData) => {

    if (!originalData || rowIndex ==="") {
      console.error(`Invalid rowIndex: ${rowIndex}. Original data length: ${originalData.length}`);
      return;
    }
  
    const updatedTable = [...tableContent];
    updatedTable[rowIndex] = { ...updatedTable[rowIndex], [columnKey]: newValue };

    console.log("Updated Table Data:", updatedTable);
    const filteredData = originalData.filter(item => item.ID === rowIndex);
    const originalRow = filteredData[0];
    console.log("Original Row:", originalRow);

    if (!originalRow) {
      console.error(`Row ${rowIndex} does not exist in originalData.`);
      return;
    }
  
    if (originalRow[columnKey] !== newValue) {
      setModifiedData(prev => {
        const existingChangeIndex = prev.findIndex(change => change.index === rowIndex);
        const modifiedRow = { ...originalRow, [columnKey]: newValue };
        if (existingChangeIndex !== -1) {
          const updatedChanges = [...prev];
          updatedChanges[existingChangeIndex].modified = modifiedRow;
          return updatedChanges;
        } else {
          return [...prev, { index: rowIndex, original: originalRow, modified: modifiedRow, ID:rowIndex }];
        }
      });
    }
  };


// Handle Save
/**
 * handleSave
 * Collects all modified rows and submits them to the API in a single batch.
 * Clears local modification state and re-fetches the selected table on success.
 * @returns {Promise<void>}
 */
const handleSave = async () => {
    // if (!selectedTable || modifiedData.length === 0) {
    //   //      alert("No changes detected.");
    //   return;
    // }
    if(tempModifedId.length === 0){
      return;
    }
    tempModifedId = [...new Set(tempModifedId)];
    let saveData = []
    for(let loop=0;loop<tempModifedId.length;loop++){
      //console.log(tempArray)
      //tempModifedId[loop]

      let modi = tempArray.filter(item => item.ID === tempModifedId[loop])[0]
      //delete modi.ID; 

      let origi = tableContent.filter(item => item.ID === tempModifedId[loop])[0]
      //delete origi.ID;  // Removes the "age" attribute

      let obj = { 
      "modified":modi,
      "original":origi
      };
      saveData.push(obj)

    }
      

    let apiUrl = API_SERVER_URL+ 'reference/data?table='+selectedTable.tableName
    let method = "POST"
    const logged_user_name = getUsername();
    try {
      const request_object = {
        tableName: selectedTable.tableName,
        last_edited_by:logged_user_name,
        //data_to_update: modifiedData.map(({ original, modified }) => ({ original, modified }))
        data_to_update: saveData
      };

      const result = await apiCall(method,apiUrl,request_object);
        const targetElement = document.getElementById("app_err");
        if(result!==undefined){
        if (result.code === API_SUCCESS_RESPONSE_CODE) {
            setModifiedData([]); // Clear modifications
            tempModifedId.length = 0;
            tempArray.length = 0;
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
            handleTableChange(tableselection)
        } else {
          if (targetElement) {
            ReactDOM.unmountComponentAtNode(targetElement);
          }
          ReactDOM.render(<Message type='error' message={result.message} />, targetElement);
          trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
        }
        }
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  return (
    <div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
        <div id="table_height">
            <div className="flex-grow-1" id="row_heading">
              <div className="page-title">Reference Data</div>
              <p className="text-muted my-2 ff-secondary">
                Reference Data feature allows users to  edit Reference data
              </p>
            </div>
            <div id="app_err"></div>
          </div>
          <Select
            options={tableOptions}
            onChange={handleTableChange}
            placeholder="Select a table..."
          />
            {loading ? <PageLoader /> :  ""  } 
            <div className={loading || tableContent.length === 0 ? "d-none" : ""}>  
            <div className="row g-2 mb-4 mt-4" id="row_search">
            <div className="col-sm-12">
              <div className="search-box">
                <input
                  type="text"
                  className="form-control"
                  id="searchClausess"
                  placeholder="Search Taxonomies..."  // This should work as expected
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <i className="grid-search">
                <CommonIcon iconName="Search" size={"14px"}  />
                </i>
              </div>
            </div>
            </div> 
                <table
                id="contract_grid"
                className="display" style={{ width: '100%' }}></table>
              <br />
              {/* disabled={tempModifedId.length===0 ? true : false} */}
              <button className="btn btn-primary float-end"  onClick={handleSave}>
                <CommonIcon iconName="Save" size={"14px"} color="#fff" /> Save
              </button>
            </div>
             {/*loading ? <PageLoader /> : selectedTable !== null ? (  ) : "" */}
        </div>
      </div>
    </div>
  );
};


// import React, { useState } from 'react';
// import Select from "react-select";
// import { API_SERVER_URL } from "../../utils/config_ip_details";
// import { apiCall } from "../../utils/server_utils";
// import PageLoader from '../common/pageloader';
// import CommonIcon from '../common/customicon';
// import { getUsername } from "../../utils/common_functions";
// import * as ReactDOM from 'react-dom';
// import {trackError} from "../../utils/error_tracker"
// import { API_SUCCESS_RESPONSE_CODE } from '../../utils/config_mapping';
// import Message from "../common/message";

// export const TableColumn = () => {
//   const [loading, setLoading] = useState(false);
//   const [selectedTable, setSelectedTable] = useState(null);
//   const [tableContent, setTableContent] = useState([]);
//   const [originalData, setOriginalData] = useState([]);
//   const [modifiedData, setModifiedData] = useState([]);

//   const tableOptions = [
//     { label: "Categories", value: "Categories" },
//     { label: "Channels", value: "Channels" },
//     { label: "Territories", value: "Territories" },
//     { label: "Gender", value: "Gender" },
//   ];

//   // Handle table selection & fetch data
//   const handleTableChange = async (selectedOption) => {
//     setLoading(true);
//     try {
//       const result = await apiCall("GET", `${API_SERVER_URL}reference/data?table=${selectedOption.value}`);
//       if (result.code === 200 && result.data.length > 0) {
//         const tableData = result.data[0]; // Assuming we only get one table at a time
//         setTableContent(tableData.columnsdata);
//         setOriginalData(tableData.columnsdata);
//         setSelectedTable({
//           tableName: tableData.tableName,
//           columnsNameList: tableData.columnsNameList,
//         });
//       }
//     } catch (error) {
//       console.error("Error fetching table data:", error);
//     }
//     setLoading(false);
//   };

//   // Handle cell edit
//   const handleCellChange = (rowIndex, columnKey, newValue) => {
//     const updatedTable = [...tableContent];
//     updatedTable[rowIndex] = { ...updatedTable[rowIndex], [columnKey]: newValue };
//     setTableContent(updatedTable);

//     // Compare original vs modified
//     const originalRow = originalData[rowIndex];
//     if (originalRow[columnKey] !== newValue) {
//       setModifiedData(prev => {
//         const existingChangeIndex = prev.findIndex(change => change.index === rowIndex);
//         const modifiedRow = { ...originalRow, [columnKey]: newValue };

//         if (existingChangeIndex !== -1) {
//           // Update existing modified row
//           const updatedChanges = [...prev];
//           updatedChanges[existingChangeIndex].modified = modifiedRow;
//           return updatedChanges;
//         } else {
//           // Add new modified row
//           return [...prev, { index: rowIndex, original: originalRow, modified: modifiedRow }];
//         }
//       });
//     }
//   };

//   // Handle Save
//   const handleSave = async () => {
//     if (!selectedTable || modifiedData.length === 0) {
// //      alert("No changes detected.");
//       return;
//     }
//     let apiUrl = API_SERVER_URL+ 'reference/data?table='+selectedTable.tableName
//     let method = "POST"
//     const logged_user_name = getUsername();
//     try {
//       const request_object = {
//         tableName: selectedTable.tableName,
//         last_edited_by:logged_user_name,
//         data_to_update: modifiedData.map(({ original, modified }) => ({ original, modified }))
//       };
//       const result = await apiCall(method,apiUrl,request_object);
//         const targetElement = document.getElementById("app_err");
//         if(result!==undefined){
//         if (result.code === API_SUCCESS_RESPONSE_CODE) {
//             setModifiedData([]); // Clear modifications
//             if (targetElement) {
//               ReactDOM.unmountComponentAtNode(targetElement);
//             }
//             ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
//         } else {
//           if (targetElement) {
//             ReactDOM.unmountComponentAtNode(targetElement);
//           }
//           ReactDOM.render(<Message type='error' message={result.message} />, targetElement);
//           trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
//         }
//         }

//       // const response = await apiCall("POST", `${API_SERVER_URL}reference/save`, payload);
//       // if (response.code === 200) {
//       //   alert("Data saved successfully!");
//       //   setModifiedData([]); // Clear modifications
//       // } else {
//       //   alert("Error saving data.");
//       // }
//     } catch (error) {
//       console.error("Save failed:", error);
//       //alert("API request failed.");
//     }
//   };

//   return (
//     <div className="main-content">
       <HeaderLogo />
//       <div className="page-content">
//         <div className="container-fluid">

//           <div id="table_height">
//             <div className="flex-grow-1" id="row_heading">
//               <div className="page-title">Reference Data</div>
//               <p className="text-muted my-2 ff-secondary">
//               Reference Data feature allows users to dynamically edit table data
//               </p>
//             </div>
//             <div id="app_err"></div>
//           </div>

//         <Select
//               options={tableOptions}
//               onChange={handleTableChange}
//               placeholder="Select a table..."
//               className="table-select"
//             />
//             <br />

//             {loading ? (
//                  <PageLoader />
//             ) :  selectedTable !==null ?
//             <>
//           <div className="table-container">
//             {selectedTable && (
//               <>
//                 <div className="table-wrapper">
//                   <table className="excel-table">
//                     <thead>
//                       <tr>
//                         {selectedTable.columnsNameList.map(col => (
//                           <th key={col}>{col}</th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableContent.map((row, rowIndex) => (
//                         <tr key={rowIndex}>
//                           {selectedTable.columnsNameList.map(columnKey => (
//                             <td key={columnKey}>
//                               <input
//                                 type="text"
//                                 value={row[columnKey] || ""}
//                                 onChange={(e) => handleCellChange(rowIndex, columnKey, e.target.value)}
//                                 className={modifiedData.some(change => change.index === rowIndex) ? "edited" : ""}
//                               />
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
                

                
//               </>
//             )}
//           </div>
//           <br/>
//           {selectedTable !== null ? 
//           <div className="row">
//           <div className="col-lg-12">
//             <button
//               className="btn btn-primary float-end"
//               onClick={handleSave}
//               >
//               <CommonIcon iconName="Save" size={"14px"} color="#fff" /> Save 
//             </button>
//           </div>
//         </div> : "" }
//         </>
          
//           : "" }
//         </div>
//       </div>
//     </div>
//   );
// };
